export default {
    showFavoriteSuggestions: {
        datapoint: {
            name: 'TnS_ShowFavoriteSuggestions',
            customData: function (searchInputLength, peopleSuggestionCount, folderSuggestionCount, searchSuggestionCount, categorySuggestionCount, groupSuggestionCount) { return [
                searchInputLength,
                peopleSuggestionCount,
                folderSuggestionCount,
                searchSuggestionCount,
                categorySuggestionCount,
                groupSuggestionCount,
            ]; },
        },
    },
    addFavoriteFromPicker: {
        datapoint: {
            name: 'TnS_AddFavoriteFromPicker',
            customData: function (searchInputLength, favoriteSuggestionType) { return [searchInputLength, favoriteSuggestionType]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map